import { Box } from "@mui/material";
import { useEffect } from "react";
import NavBar from "src/components/NavBar/NavBar";

function ContactUs() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    const typeformDiv = document.querySelector("[data-tf-live]");
    if (typeformDiv) {
      typeformDiv.setAttribute("data-tf-live", process.env.REACT_APP_TYPEFORM_ID || "default-id");
    }

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Box sx={{ marginTop: "70px" }}>
        <NavBar />

        <Box pt={4}>
          {/* I added these styles to avoid a bouncing that happens with the typeform bar before it is fully rendered  */}
          <div
            data-tf-live="default-id"
            style={{
              minHeight: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          ></div>
        </Box>
      </Box>
    </>
  );
}

export default ContactUs;
